export default __webpack_public_path__ + "static/media/bg25.bf286038.jpg";